import { Role } from '../../types/app/role.types';
import { api } from '../core/api';

export const getRoleList = () => api.get<Role[]>('Role/GetList').then((res) => res.data);
